import { render, staticRenderFns } from "./diccionario.vue?vue&type=template&id=e4b5d7d0"
import script from "./diccionario.vue?vue&type=script&lang=js"
export * from "./diccionario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports